const {goToNextStep} = require("../../../utils/nextStepAction");
const uuidv4 = require("uuid/v4");
const {PAGE_ACTIONS} = require("../../../../constants/app");
const {EXPRESS_SET_INSTALLMENTS_ERROR} = require("../../../spa/actions/types");

const useActions = (
  {
    flow,
    history,
    stepActions,
    captcha,
    requestActions,
    captchaConfig = {},
    captchaToken = {},
    paymentMethod,
    express,
    showInstallments,
    expressActions,
  }) => {

  const requestId = uuidv4();

  const isValidInstallments = () => {
    const isInstallmentsValid = express?.installments?.[paymentMethod.option_id]?.value;
    if (showInstallments && !isInstallmentsValid) {
      expressActions[EXPRESS_SET_INSTALLMENTS_ERROR](paymentMethod.option_id, !isInstallmentsValid);
      return false;
    }
    return true;
  }

  const nextStepAction = () => {
    const methodId = paymentMethod?.option_id;
    const installments = express?.installments?.[methodId]?.value || 1;

    if (!isValidInstallments()) {
      return null;
    }

    const data = {
      id: PAGE_ACTIONS.NEXT_STEP,
      values: {
        installments
      },
    };

    return goToNextStep(
      {
        data,
        flow,
        history,
        stepActions,
        captcha,
        requestActions,
        requestId,
        captchaConfig,
        captchaToken,
      });
  };

  return {
    nextStepAction
  }
}

module.exports = useActions;
